<template>
  <div>
    <div class="header-icas clearfix">
      <div v-if="!isOS || uiConfig.sfTheme" class="fl logo">
        <img src="@/assets/common/logo.png" alt="">
        <span class="divider-logo" />
        <span class="title">{{ getLogoTitle() }}</span>
      </div>
      <img v-else-if="isMy" src="@/assets/common/ic_abx_logo.jpg" alt="" class="logo-icon">
      <img v-else src="@/assets/common/ic_os_kex_new.svg" alt="" class="logo-icon">

      <div class="fr info">
        <div v-if="uiConfig.cooperationConsulting" class="item">
          <Consult />
        </div>
        <div class="item">
          <Homepage v-if="uiConfig.internationalWebsite" />
        </div>
        <div v-show="!isOS" class="item">
          <site-select :show-memu="false" />
        </div>
        <div class="item">
          <lang-select />
        </div>
        <div class="item">
          <quit-info />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Homepage from '@/components/Homepage'
import Consult from '@/components/Consult'
import LangSelect from '@/components/LangSelectIcon'
import SiteSelect from '@/components/SiteSelectIcon'
import QuitInfo from '@/components/QuitInfo'
import { isOS } from '@/utils/constant'
import { isMy } from '../../utils/constant'

export default {
  // 主页用户信息组件
  name: 'AppHeader',
  components: {
    Consult,
    Homepage,
    SiteSelect,
    LangSelect,
    QuitInfo
  },
  data: function() {
    return {
      isOS: isOS(),
      isMy: isMy()
    }
  },
  computed: {
    ...mapGetters(['language', 'uiConfig']),
  },
  methods: {
    getLogoTitle() {
      if (this.language === 'zh-CN') {
        return this.uiConfig.officialWebsiteLogoText['zh-CN']
      } else if (this.language === 'zh-HK') {
        return this.uiConfig.officialWebsiteLogoText['zh-HK']
      } else if (this.language === 'en') {
        return this.uiConfig.officialWebsiteLogoText['en']
      } else if (this.language === 'ja-JP') {
        return this.uiConfig.officialWebsiteLogoText['ja-JP']
      } else if (this.language === 'ko-KR') {
        return this.uiConfig.officialWebsiteLogoText['ko-KR']
      } else if (this.language === 'vi-VN') {
        return this.uiConfig.officialWebsiteLogoText['vi-VN']
      } else {
        return this.uiConfig.officialWebsiteLogoText['default']
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.logo-icon{
        display: inline-block;
        vertical-align: middle;
        height: 36px;
      }
      .divider-logo {
    height:28px;
    width: 1px;
    background: white;
    margin-top: auto;
    margin-left: 20px !important;
    // margin-left: 14px !important;
    margin-bottom: auto;
  }
.header-icas{
    min-width: 1024px;
    padding: 0 24px;
    font-size: 0;
    height:64px;
    line-height: 64px;
    color: $color01;
    background:$color02;
    box-shadow:0px -2px 8px 0px rgba(0,21,41,0.12);
    .logo{
      height: 64px;
      line-height: 64px;
      img {
        display: inline-block;
        vertical-align: middle;
        width: 36px;
        height: 36px;
      }
      span{
        display: inline-block;
        vertical-align: middle;
        margin-left: 16px;
        font-size:16px;
        color:$color01;
      }
    }
    .info{
      font-size:14px;
      .item{
        position: relative;
        display: inline-block;
        cursor: pointer;
        &+.item{
          margin-left: 24px;
        }
        >span{
          display: inline-block;
          vertical-align: middle;
        }
        >img{
          display: inline-block;
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
        .user{
          width: 24px;
          height: 24px;
        }
    }
  }
}
</style>
